export const routesMusteri = [
  {
    path: "/musteriler",
    name: "musteri-list",
    component: () => import("@/views/musteriler/index.vue"),
    meta: {
      public: false,
      title: "Müşteriler",
      yetki: { k: [2000002] },
    },
  },
]
